/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon20Solid = forwardRef('MediaAudioVolumeAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m7.682 6 4.781-4.573C13.417.514 15 1.19 15 2.51V17.49c0 1.32-1.583 1.996-2.537 1.084L7.682 14H4.25A2.25 2.25 0 0 1 2 11.75v-3.5A2.25 2.25 0 0 1 4.25 6h3.432Z" })));
});
